module.exports = __webpack_public_path__ + "static/media/background.06698fe1.jpg";